// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.components-container div[data-v-153ef6f8] {\n  margin: 10px;\n}\n.time-container[data-v-153ef6f8] {\n  display: inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
